module.exports = __webpack_public_path__ + "static/media/call_receive.8b8bebce.png";